import {fetchOptions} from '../../../entity-form/fetch-options';

export const useGetParticipants = (): {
    getParticipants: (searchTerm?: string | null | undefined) => Promise<any>;
} => {
    const getParticipants = (searchTerm?: string | null) => {
        // @ts-expect-error
        return fetchOptions(['contacts', 'accounts', 'users'])(searchTerm || '');
    };

    return {getParticipants};
};
